import { type Editor, posToDOMRect } from "@tiptap/core";
import { NodeSelection } from "@tiptap/pm/state";
import { resolveToolbarContext } from "./resolveToolbarContext";

const mediaNodes = new Set(["image", "diagrams", "drawio", "video", "html"]);

const groupNodes = new Set(["gallery"]);

export const BLOCK_ANCHOR_ATTR = "data-block-toolbar-anchor";
export const GROUP_ANCHOR_ATTR = "data-block-toolbar-group-anchor";

export const getToolbarReferenceRect = (editor: Editor): DOMRect => {
	if (!editor || editor.isDestroyed) return new DOMRect();
	const { state, view } = editor;
	const context = resolveToolbarContext(state);

	if (context.kind === "file") return posToDOMRect(view, context.from, context.to);

	if (context.kind === "node" || context.kind === "container") {
		const pos = context.kind === "node" ? (context.parentPos ?? context.pos) : context.pos;
		const node = view.nodeDOM(pos) as HTMLElement;
		const type = state.doc.nodeAt(pos)?.type.name;
		const anchorAttr = groupNodes.has(type) ? GROUP_ANCHOR_ATTR : mediaNodes.has(type) ? BLOCK_ANCHOR_ATTR : null;
		const anchor = (anchorAttr && node?.querySelector<HTMLElement>(`[${anchorAttr}]`)) || node;
		if (anchor) return anchor.getBoundingClientRect();
	}

	const { selection } = state;
	const from = Math.min(...selection.ranges.map((range) => range.$from.pos));
	const to = Math.max(...selection.ranges.map((range) => range.$to.pos));

	if (selection instanceof NodeSelection) {
		const node = view.nodeDOM(from) as HTMLElement;
		const wrapper = node?.dataset.nodeViewWrapper ? node : node?.querySelector("[data-node-view-wrapper]");
		const anchor = (wrapper?.firstChild as HTMLElement) ?? node;
		if (anchor) return anchor.getBoundingClientRect();
	}

	return posToDOMRect(view, from, to);
};
